import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/bettyblocks.webp';
import screenshot_target from '../../../images/letterfunnel/chrisobdam.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Chris Obdam"
      firstname="Chris"
      companyname="Betty Blocks"
      competition="Mendix en Microsoft Power Apps"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/chrisobdam.js